//Logic for RolePermissions

var secAreaMaskList = new Array();
var currentIndex = -1;

$(document).ready(function () {
    CollapseHideInit();
});

function CollapseHideInit() {
    secAreaMaskList = new Array();
    currentIndex = -1;

    $(".collapse").on('shown.bs.collapse', function () {
        if (typeof colResizable === "function") {
            $(".tmtable.resizable:visible").colResizable({ disable: true });
            $(".tmtable.resizable:visible").colResizable({
                liveDrag: true,
                resizeMode: 'overflow',
            });
        }

        SizePanel();
    });

    $(".collapse").on('hidden.bs.collapse', function () {
        SizePanel();
    });
}

function CaretChange(ctrl) {
    SizePanel();
    var carret = $(ctrl).find(".k-i-expand");
    if (carret.length == 0)
        $(ctrl).find(".k-i-collapse").removeClass("k-i-collapse").addClass("k-i-expand");
    else
        carret.removeClass("k-i-expand").addClass("k-i-collapse");
}

// Object defined
function secAreaMask(secAreaId, rowMask, isNew) {
    this.SecAreaId = secAreaId;
    this.RowMask = rowMask;
    this.IsNew = isNew;

    this.toString = getSerializedObject;
}

// Called by Checkboxes when they are checked or unchecked
function uMsk(ctrl) {
    sessionStorage.IsFormDirty = true;
    $("#btnSave").prop("disabled", false);
    var chkBox = $(ctrl);
    var chkBoxId = chkBox.attr("id");
    var groupId = chkBoxId.substring(0, chkBoxId.lastIndexOf("ctl")) + "ctl1" + chkBoxId.substring(chkBoxId.lastIndexOf("_"));
    UpdateMask(chkBox, 0, groupId);
}

// Called by Header Checkboxes when they are checked or unchecked
function chk(ctrl) {
    sessionStorage.IsFormDirty = true;
    $("#btnSave").prop("disabled", false);
    var chkBox = $(ctrl);
    var chkId = chkBox.attr("id");
	var suffix = chkId.substring(chkId.lastIndexOf("_"));
	var prefix = chkId.substring(0, chkId.lastIndexOf("ctl"));
		
	var prefixFound = false;
	var currSuffix = '';
	var chkBoxes = new Array();
	$(":checkbox").each(function () {
	    var id = $(this).attr("id");
			
	    // Return for next group of Ids
	    if(id.indexOf(prefix) == -1)
	        if (prefixFound)
	            return false;
	        else
                return;
				
	    prefixFound = true;
	    currSuffix = id.substring(id.lastIndexOf("_"));
	    if(currSuffix == suffix && id != chkId)
	    {
	        $(this).prop("checked", chkBox.prop("checked"));
	        chkBoxes[chkBoxes.length]=$(this);
	    }
	});

	for(var i=0;i<chkBoxes.length;i++)
		UpdateMask(chkBoxes[i], 1, chkId);
}

function UpdateMask(chkBox, isGroupChk, groupId) {  
    var rowMask = chkBox.parent().attr("rm");
    var colMask = chkBox.parent().attr("cm");
    var sAreaId = chkBox.parent().attr("sid");

    var tempsecAreaMask = null;
    tempsecAreaMask = getSecAreaRowMask(sAreaId);

    if (tempsecAreaMask == null)
        tempsecAreaMask = new secAreaMask(sAreaId, rowMask, rowMask == 0);

    //Bitwise operations with Long datatype are applied to a 32bit signed integer (1 bit of 32 is for sign)
    var rowMaskH = tempsecAreaMask.RowMask;
    var rowMaskL = tempsecAreaMask.RowMask;

    rowMaskH = rowMaskH < 2147483648 ? 0 : parseInt(rowMaskH / 2147483648, 10);
    rowMaskL = rowMaskL - rowMaskH * 2147483648;

    var colMaskH = colMask;
    var colMaskL = colMask;

    colMaskH = colMaskH < 2147483648 ? 0 : parseInt(colMaskH / 2147483648, 10);
    colMaskL = colMaskL - colMaskH * 2147483648;

    var isChecked = chkBox.prop("checked");
    rowMaskH = isChecked ? (rowMaskH | colMaskH) : (rowMaskH & ~colMaskH);
    rowMaskL = isChecked ? (rowMaskL | colMaskL) : (rowMaskL & ~colMaskL);

    tempsecAreaMask.RowMask = (rowMaskH * 2147483648) + rowMaskL;

    UpdateHeaderChk(isChecked, isGroupChk, groupId);
    AddToArray(tempsecAreaMask);
}

function UpdateHeaderChk(isChecked, isGroupChk, groupId) {
    var chkBox = $("#"+groupId)
    var spanChk = chkBox.closest("span");

    var totalCnt = parseInt(spanChk.attr("tcnt"), 10);
    var currentCnt = parseInt(spanChk.attr("cnt"), 10);

    if (isChecked) {
        currentCnt = isGroupChk ? totalCnt : currentCnt + 1;
        spanChk.attr("cnt", currentCnt);

        if (totalCnt == currentCnt)
            chkBox.prop("checked", true);
    }
    else {
        spanChk.attr("cnt", isGroupChk ? 0 : (currentCnt - 1));
        chkBox.prop("checked", false);
    }
}

// Adds Item to array
function AddToArray(newObject) {
    if (secAreaMaskList == null)
        secAreaMaskList = new Array();

    if (currentIndex != -1)
        secAreaMaskList[currentIndex] = newObject;
    else
        secAreaMaskList[secAreaMaskList.length] = newObject;

    currentIndex = -1;
    UpdateServerControl();
}

// Update the server TextBox for access by form
function UpdateServerControl() {
    $("#infoHidden").val(GetSerializedArray())
}

// Serialize Array
function GetSerializedArray() {
    var arrayToString = "";
    if (secAreaMaskList != null) {
        for (i = 0; i < secAreaMaskList.length; i++) {
            arrayToString += secAreaMaskList[i].toString();
            if (i < secAreaMaskList.length - 1)
                arrayToString += ";";
        }
    }

    return arrayToString;
}

// Serialize object
function getSerializedObject() {
    return this.SecAreaId + "," + this.RowMask + "," + this.IsNew;
}

// Object Method Defined
function getSecAreaRowMask(secAreaId) {
    var currentRowMask = -1;
    var currentObject = null;

    // Search thru the entire array Collection
    // and return the rowmask for the matched SecAreaId
    if (secAreaMaskList != null && secAreaMaskList.length > 0) {
        var i;
        for (i in secAreaMaskList) {
            if (secAreaMaskList[i].SecAreaId == secAreaId) {
                currentObject = secAreaMaskList[i];
                currentIndex = i;
                break;
            }
        }
    }
    return currentObject;
}

function PrintClick() {
    var pageTitle = GetPageTitle();
    // append a (hidden) container for the printing clone
	$("body").append('<div id="printDivContainer"><div id ="printDiv" class="popupMessage container-fluid"><div id="test"></div></div></div>');

	// clone print area and append to container
	var printClone = $("#mainPanelBody").clone();
    printClone.appendTo($("#printDiv"));
	// get the print div
	var printDiv = $("#printDiv");

	var height = '90%'; var width = '90%';
	// use container as reference for height and width.
	var refHeight = $("#mainPanelBody").height() + 250;
	if (refHeight < $(window).height())
		height = refHeight;

	var refWidth = $("#mainPanelBody").width() - 150;
	if (refWidth < $(window).width())
		width = refWidth;

    //expanding and collapsing adds classes and attributes that need to be removed
    printDiv.find('.accordian-body.collapse:not(.show)').each( function() {
        $(this).addClass('show');
        $(this).removeAttr('style');
        $(this).removeAttr("aria-expanded");
    });

    printDiv.find('div[data-toggle]').each( function() {
        $(this).removeAttr("aria-expanded");
    });

    printDiv.find(".collapsed").each(function(){
        $(this).removeClass("collapsed");
    });

    printDiv.find($("div")).each(function () {
        $(this).css("overflow-x", "");
        $(this).css("overflow-y", "");
    });

	PrintConfigPageGridCommon(printDiv, pageTitle, height, width);

	$("#printDivContainer").remove();
}






